import { render } from "./PageFooters.vue?vue&type=template&id=286659fa&scoped=true"
import script from "./PageFooters.vue?vue&type=script&lang=js"
export * from "./PageFooters.vue?vue&type=script&lang=js"

import "./PageFooters.vue?vue&type=style&index=0&id=286659fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286659fa"]])

export default __exports__